export const categories = [
  {
    slug: 'football',
    name: '足球竞猜',
    icon: 'ri-football-line',
    description: '全球顶级足球赛事竞猜，涵盖英超、西甲、意甲、德甲、法甲等五大联赛及欧冠、世界杯等国际赛事。',
    matchCount: 128,
    popularLeagues: ['英超', '西甲', '意甲', '德甲', '法甲', '欧冠', '世界杯'],
  },
  {
    slug: 'basketball',
    name: '篮球竞猜',
    icon: 'ri-basketball-line',
    description: 'NBA、CBA、欧冠篮球等顶级篮球赛事实时竞猜，比分直播与专业分析一应俱全。',
    matchCount: 96,
    popularLeagues: ['NBA', 'CBA', '欧洲篮球联赛', 'NCAA'],
  },
  {
    slug: 'tennis',
    name: '网球竞猜',
    icon: 'ri-trophy-line',
    description: '四大满贯赛事及ATP、WTA巡回赛全覆盖，精准赔率与实时数据助您把握每一个得分瞬间。',
    matchCount: 64,
    popularLeagues: ['温网', '法网', '澳网', '美网', 'ATP巡回赛'],
  },
  {
    slug: 'esports',
    name: '电竞竞猜',
    icon: 'ri-gamepad-line',
    description: 'LOL、DOTA2、CS:GO、王者荣耀等热门电竞项目竞猜，紧跟年轻人的竞技潮流。',
    matchCount: 72,
    popularLeagues: ['LPL', 'LCK', 'Major', 'TI国际邀请赛'],
  },
  {
    slug: 'other',
    name: '其他赛事',
    icon: 'ri-medal-line',
    description: '乒乓球、羽毛球、排球、F1赛车、高尔夫等多元体育项目竞猜，丰富您的投注选择。',
    matchCount: 48,
    popularLeagues: ['F1大奖赛', '羽毛球世锦赛', '排球联赛', '高尔夫大师赛'],
  },
];

export const featuredMatches = [
  {
    id: 1,
    league: '英超联赛',
    home: '曼彻斯特城',
    away: '利物浦',
    homeIcon: 'ri-shield-star-line',
    awayIcon: 'ri-shield-flash-line',
    time: '2026-08-09 03:00',
    odds: { home: 2.10, draw: 3.50, away: 3.20 },
    category: 'football',
  },
  {
    id: 2,
    league: 'NBA',
    home: '洛杉矶湖人',
    away: '金州勇士',
    homeIcon: 'ri-shield-star-line',
    awayIcon: 'ri-shield-flash-line',
    time: '2026-08-09 10:30',
    odds: { home: 1.85, away: 1.95 },
    category: 'basketball',
  },
  {
    id: 3,
    league: '西甲联赛',
    home: '皇家马德里',
    away: '巴塞罗那',
    homeIcon: 'ri-shield-star-line',
    awayIcon: 'ri-shield-flash-line',
    time: '2026-08-10 04:00',
    odds: { home: 2.40, draw: 3.30, away: 2.80 },
    category: 'football',
  },
  {
    id: 4,
    league: 'LPL夏季赛',
    home: 'JDG',
    away: 'BLG',
    homeIcon: 'ri-shield-star-line',
    awayIcon: 'ri-shield-flash-line',
    time: '2026-08-09 17:00',
    odds: { home: 1.75, away: 2.05 },
    category: 'esports',
  },
  {
    id: 5,
    league: '温网公开赛',
    home: '德约科维奇',
    away: '阿尔卡拉斯',
    homeIcon: 'ri-shield-star-line',
    awayIcon: 'ri-shield-flash-line',
    time: '2026-08-11 20:00',
    odds: { home: 1.90, away: 1.90 },
    category: 'tennis',
  },
  {
    id: 6,
    league: 'NBA',
    home: '波士顿凯尔特人',
    away: '密尔沃基雄鹿',
    homeIcon: 'ri-shield-star-line',
    awayIcon: 'ri-shield-flash-line',
    time: '2026-08-10 08:00',
    odds: { home: 1.65, away: 2.25 },
    category: 'basketball',
  },
];